export default __webpack_public_path__ + "static/33ca2000-af7b-4444-97cd-6392ab2e24b2-d241888a8a8f0343e114f02fceafc391.woff2";